import React, { useEffect, useState, useRef } from 'react';
import '../Dashboard/Dashboard.css';
import '../../App.css';
import API from "../../Services/Dashboard";
import { toast } from 'react-toastify';
import AddWaiver from "../../Pages/Waiver/AddWaiver";
import WaiverForm from "../../Pages/WaiverForm";
import { v4 as uuidv4 } from "uuid";

const Dashboard = ({ cardDetails }) => {
  const [items, setItems] = useState([]);
  const [product, setProduct] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [message, setMessage] = useState("");
  const [productType, setproductType] = useState("");
  const [countdownTimer, setCountdownTimer] = useState(580);
  const [showWaiver, setShowWaiver] = useState(false);
  const [showDashboard, setDashboard] = useState(true);
  const [waiverLength, setWaiverLength] = useState(0)
  const newIdempotencyKey = () =>
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : uuidv4();

  const submittingRef = useRef(false);
  const idempotencyKeyRef = useRef(newIdempotencyKey());
  useEffect(() => {
    if (localStorage.getItem("selectedProductTypeId") != null) {
      getProduct(localStorage.getItem("selectedProductTypeId"));
      console.log('cardDetails', cardDetails);
    }
    else {
      window.location.replace("/ProductType")
    }
  }, [cardDetails]);

  const getProduct = async (product_type_id) => {
    try {
      const response = await API.getProduct(product_type_id);
      if (response?.status === 200) {
        setProduct(response?.data?.data);
        setproductType(response.data?.product_type_name)
      } else {
        console.error('Unexpected response:', response);
      }
    } catch (error) {
      if (error?.response?.status === 403) {
        window.location.replace("/Login")
      } else {
        toast.error("Failed to fetch product. Please try again later.");
      }
    }
  };

  const handleAddItem = (id) => {
    const selected = product.find((p) => p.id === id);
    if (selected) {
      const alreadyAdded = items.some(item => item.name === selected.name);
      if (!alreadyAdded) {
        setItems((prev) => [...prev, { name: selected.name, amount: selected.amount, qty: 1 }]);
      }
    }
  };

  const handleDeleteItem = (index) => {
    setItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleQtyChange = (index, qty) => {
    const updatedItems = [...items];
    updatedItems[index].qty = parseInt(qty);
    setItems(updatedItems);
  };

  const calculateTotalPoints = () => {
    return items.reduce((sum, item) => sum + (item.amount * (item.qty || 1)), 0);
  };




  const calculateTotalQty = () => {
    return items.reduce((sum, item) => sum + (item.qty || 1), 0);
  };



  const handlePay = async () => {
    if (submittingRef.current) return;
    if (items.length === 0) {
      toast.error("At least one item must be selected.");
      return;
    }
    const cardId = cardDetails[0].id;
    const priceTypeId = 2;
    const isCombo = 0;
    const discountTypeId = 0;
    const discountReasonId = 0;
    try {
      const payload = {
        data: items.map((item) => {
          const productDetails = product.find(p => p.name === item.name) || {};
          return {
            id: productDetails.id || null,
            company_id: productDetails.company_id || null,
            name: item.name,
            product_type_id: productDetails.product_type_id || null,
            display_order: productDetails.display_order || 0,
            amount: item.amount,
            description: productDetails.description || "",
            time: productDetails.time || null,
            price_type_id: productDetails.price_type_id || priceTypeId,
            is_combo: productDetails.is_combo || false,
            tax_type_id: productDetails.tax_type_id || null,
            track_inventory: productDetails.track_inventory || false,
            is_recipe: productDetails.is_recipe || false,
            is_active: productDetails.is_active !== undefined ? productDetails.is_active : true,
            createdAt: productDetails.createdAt || null,
            updatedAt: productDetails.updatedAt || null,
            product_code: productDetails.product_code || null,
            machine_id: productDetails.machine_id || null,
            mrp: productDetails.mrp || null,
            is_party: productDetails.is_party || false,
            product_id: productDetails.product_id || productDetails.id || null,
            product_name: item.name,
            quantity: item.qty,
            price: item.amount,
            tax_type_rate: productDetails.tax_type_rate || 0,
            
            
          };
        }),
        priceTypeId,
        is_combo: isCombo,
        discount_type_id: discountTypeId,
        discount_reason_id: discountReasonId,
        payment_mode: [],
        card_id: cardId,
        total_amount: calculateTotalPoints(),
        idempotency_key: idempotencyKeyRef.current,
      };
      submittingRef.current = true;
      console.log("Payload to send:", payload);
      // let orderPlaced = false;
      const response = await API.update_stock(payload);
      if (response.status === 200 && response.data?.message) {
        toast.success(response.data.message);
        setMessage(response.data.message);
        if (localStorage.getItem("isWaiverRequired") === "true") {
          setDashboard(false);
          setShowWaiver(true);
          //window.location.replace("/CardSwipe")
        } else {
          setShowMessage(true);
          setCountdown(5);
          const interval = setInterval(() => {
            setCountdown(prev => {
              if (prev <= 1) {
                clearInterval(interval);
                setShowMessage(false);
                window.location.replace("/CardSwipe")
              }
              return prev - 1;
            });
          }, 1000);
        }
      }
      else {
        toast.error("Payment succeeded, but response was unexpected.");
      }
    } catch (error) {
      // console.error("Error during handlePay:", error);
      // toast.error("An error occurred while processing the payment.");
      if (error?.response?.status === 403) {
        window.location.replace("/Login")
      } else {
        toast.error("An error occurred while processing the payment.");
      }

    }
  };



  useEffect(() => {
    const interval = setInterval(() => {
      setCountdownTimer((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          handleBack();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleBack = () => {
    window.location.reload();
  }
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };
  return (
    <div>
      {showDashboard && (
        <div className="container mt-5">
          <div className="row g-4">
            <div className="col-md-5">
              <div className="card rounded shadow-sm">
                <div className="card-header text-white fw-bold rounded-0" style={{ backgroundColor: "#4D1C8D" }}>
                  {productType}
                </div>
                <div className="card-body">
                  <div className='row'>
                    {product.map((item) => (
                      <div className="col-sm-4 mb-3" key={item.id}>
                        <button className="btn btn-secondary w-100" onClick={() => handleAddItem(item.id)}>
                          {item.name}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-7">
              <div className="card rounded-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex justify-content-end mb-3">
                    <button className="btn btn-secondary btn-sm" onClick={handleBack}>Reset</button>

                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6><strong>Name:</strong> {cardDetails[0]?.customer_name}</h6>
                    <h6><strong>Available Point:</strong> {cardDetails[0]?.play_points}</h6>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6><strong>MemberShip:</strong> {cardDetails[0]?.membership}</h6>
                    <h6><strong>Ticket:</strong> {cardDetails[0]?.tickets}</h6>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6><strong>Loyalty Point:</strong> {cardDetails[0]?.loyalty_points}</h6>

                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered text-center">
                      <thead>

                        <tr className="text-white" style={{ textAlign: "center" }}>
                          <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Sr.</th>
                          <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Item Name</th>
                          <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Qty</th>
                          <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Points/Unit</th>
                          <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Total Points</th>
                          <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, index) => {
                          // console.log('items',items.length);

                          const total = item.amount * (item.qty || 1);
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.name}</td>
                              <td>
                                <select
                                  className="form-select form-select-sm"
                                  value={item.qty || 1}
                                  onChange={(e) => handleQtyChange(index, e.target.value)}
                                >
                                  {[...Array(50)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                      {i + 1}
                                    </option>
                                  ))}
                                </select>

                                {/* <select
                                  className="form-select form-select-sm"
                                  value={item.qty || 1}
                                  onChange={(e) => handleQtyChange(index, e.target.value)}
                                >
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                   <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                </select> */}
                              </td>
                              <td>{item.amount}</td>
                              <td>{total}</td>
                              <td>
                                <button className="btn btn-sm btn-danger" onClick={() => handleDeleteItem(index)}>
                                  <i className="fa fa-trash-o"></i>
                                </button>

                                {/* {index > 0 ? <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDeleteItem(index)}
                                >
                                  <i className="fa fa-trash-o"></i>
                                </button> : ""} */}

                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                  </div>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      className="btn text-white w-100 d-flex justify-content-between rounded-0"
                      style={{ minWidth: "400px", backgroundColor: "#52AF45" }}
                      onClick={handlePay}
                    >
                      <span>Pay Now </span>
                      <span>{calculateTotalPoints()}</span>
                      {/* <span>{item.length}</span> */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showMessage && (
        <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Redemption Status</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowMessage(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <h5 className="text-enter">{message}</h5>
                <p className="text-center">Closing in {countdown} second(s)...</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={() => setShowMessage(false)}>
                  Close Now
                </button>
              </div>
            </div>
          </div>
        </div>

      )}
      {showWaiver && (
        <WaiverForm Waiverlength={calculateTotalQty()} card_id={cardDetails[0]?.id} />
      )}
      <div
        className="session-expired-footer w-100 position-fixed bottom-0 start-0 bg-danger text-white text-center py-2"
        style={{ zIndex: 1050 }}
      >
        <strong> Session Expire In ! </strong>
        {formatTime(countdownTimer)}
      </div>


    </div>
  );
};

export default Dashboard;
